import { defineChain as viemDefineChain } from 'viem'

import type { AppChain } from './chain.types'

const viemRobinhood = viemDefineChain({
  id: 4663,
  name: 'Robinhood Chain',
  nativeCurrency: {
    name: 'Ether',
    symbol: 'ETH',
    decimals: 18
  },
  rpcUrls: {
    default: { http: ['https://rpc.robinhood.com'] }
  },
  blockExplorers: {
    default: {
      name: 'Robinhood Explorer',
      url: 'https://explorer.robinhood.com'
    }
  },
  contracts: {
    multicall3: {
      address: '0xcA11bde05977b3631167028862bE2a173976CA11'
    }
  }
})

export const robinhood = {
  ...viemRobinhood,
  custom: {
    name: 'Robinhood Chain',
    shortName: 'Robinhood Chain',
    morphoChainSlug: 'robinhood',
    hasFullSupport: true,
    blockExplorer: { baseUrl: 'https://explorer.robinhood.com', name: 'Robinhood Explorer' },
    contracts: {
      v1: {
        AdaptiveCurveIrm: {
          address: '0x2BD3d5965B26B51814AC95127B2b80dD6CcC0fa1',
          startBlock: 286n
        },
        MorphoBlue: { address: '0x9D53d5E3bd5E8d4Cbfa6DB1ca238AEA02E651010', startBlock: 286n }
      },
      v2: {
        VaultV20Factory: {
          address: '0x0FBad98595b0186dA120E41f77C102beb49f803c',
          startBlock: 286n
        },
        MorphoMarketV1AdapterV2Factory: {
          address: '0x79370Ed003CE325C088E530d5e8655c99c2993e1',
          startBlock: 286n
        },
        RegistryList: {
          address: '0xe785a2eFD384BA7B95BaEd3851BC76aeD67C676f',
          startBlock: 286n
        },
        BluePublicAllocator: {
          address: '0xCe5c1aFa115fF8b1D6913509bfc79D9AE08CC857',
          startBlock: 38318973n
        }
      }
    }
  }
} as const satisfies AppChain<{ v1: true; v2: true }>
